<template>
  <v-container fluid>
    <v-layout>
      <v-row>
        <v-col cols="12" md="8" class="pt-0">
          <v-card>
            <v-img
              :src="getBackImageBienvenida"
              gradient="to bottom, rgba(0,0,0,0.3), rgba(0,0,0,1)"
              class="d-flex align-end justify-center"
            >
              <div class="white--text text-h3 text-end ma-2">
                Test Adaptativo UNI
              </div>
            </v-img>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" class="pt-0">
          <p class="text-h5">Indicaciones</p>
          <v-list>
            <v-list-item v-for="(item, index) in indicaciones" :key="index">
              <v-list-item-icon
                ><v-icon :color="item.color">{{
                  item.icon
                }}</v-icon></v-list-item-icon
              >
              <v-list-item-content>
                <v-list-item-title
                  class="text-body-1 font-weight-light"
                  style="white-space: normal"
                  >{{ item.text }}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="12" sm="12">
          <template
            v-if="
              estadoTest.tieneTestPendiente || estadoTest.habilitadoNuevoTest
            "
          >
            <v-btn
              block
              color="success"
              :loading="fetching"
              @click="onStartTest"
              >{{
                estadoTest.tieneTestPendiente
                  ? 'Continuar el Test'
                  : 'Empezar Test'
              }}</v-btn
            >
          </template>
          <template v-else>
            <v-btn block color="indigo" dark :to="{ path: '/usuario/perfil' }"
              ><v-icon left>mdi-open-in-new</v-icon>Ver Resultados en el
              Perfil</v-btn
            >
          </template>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      indicaciones: [
        {
          icon: 'mdi-alarm-light',
          color: 'red',
          text: 'Asegurate de terminar el cuestionario en el primer intento, los resultados no se guardan hasta terminar el test.'
        },
        {
          icon: 'mdi-calendar-clock',
          color: 'green',
          text: 'Si terminas el test, podrás volver a tomarlo dentro de 6 meses contando desde el último intento realizado.'
        },
        {
          icon: 'mdi-account-tie',
          color: 'indigo',
          text: 'Asegúrate de responder las preguntas con sinceridad, el resultado es un reflejo de tu perfil como profesional.'
        },
        {
          icon: 'mdi-alert-circle-check',
          color: 'bolsa-guinda',
          text: 'Podrás observar los resultados obtenidos en la página de Perfil.'
        }
      ],
      estadoTest: {}
    }
  },

  methods: {
    async onStartTest() {
      if (
        !this.estadoTest.tieneTestPendiente &&
        this.estadoTest.habilitadoNuevoTest
      )
        await this.startTest()
      await this.fetchNextQuestionTest()
      this.$emit('change-step', 1)
    },

    ...mapActions('user', [
      'fetchStateTest',
      'startTest',
      'fetchNextQuestionTest'
    ])
  },

  computed: {
    getBackImageBienvenida() {
      return require('@/assets/test.png')
    },

    ...mapGetters('user', ['fetching', 'getStateTest'])
  },

  async mounted() {
    await this.fetchStateTest()
    this.estadoTest = this.getRawObject(this.getStateTest)
    //this.estadoTest.habilitado = false;
    console.log(this.estadoTest)
  }
}
</script>

<style>
</style>
